import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import moment from 'moment';
import AlertItem from './AlertItem';
import OrderAlertTable from './OrderAlertTable';


class NumberOfOrdersAlert extends Component {
  render() {
    const { alert } = this.props;

    return (
      <AlertItem
        alert={alert}
        date={moment(alert.date).format('MMMM YYYY')}
        icon='stack-overflow'
        title={(
          <div>
            <Link to={`/corporate/analyze/buyer/${alert.buyer.id}`}>
              {alert.buyer.name}
            </Link>
            {' '} placed {' '}
            <strong className='u-colorRed'>
              {alert.value.count}
            </strong>
            {' '} orders in {moment(alert.date).format('MMMM')} from
            {' '} {alert.value.supplier_name ? alert.value.supplier_name : 'all suppliers'}
          </div>
        )}
        content={(
          <OrderAlertTable
            includeExport={true}
            orders={alert.value.orders}
            type='order'
          />
        )}
        {...this.props}
      />
    );
  }
}

NumberOfOrdersAlert.propTypes = {
  alert: PropTypes.object.isRequired,
  onIsDeletedChange: PropTypes.func.isRequired,
  onIsFlaggedChange: PropTypes.func.isRequired
};

export default NumberOfOrdersAlert;
